import styled from '@emotion/styled';

export const LogoIcon = styled('img')(() => ({
  width: '240px',
  height: '52px',
}));

export const LogoIconSmall = styled('img')(() => ({
  width: '198px',
  height: '42px',
}));
